module.exports = __webpack_public_path__ + "static/media/aboutus1.911dd8cd.svg";